import i18n from "@/languageConfig"
import {
  type ContentSidebarHeaderContext,
  useContentSidebarStore,
} from "@/stores/content-sidebar-store"

import { LocalFilePreviewContent } from "./local-file-preview-content"
import { LocalFilePreviewSidebarHeader } from "./local-file-preview-sidebar-header"

export type LocalFilePreviewPanelOptions = {
  backLabel?: string
  preserveSidebarStack?: boolean
}

export function openLocalFilePreviewPanel(file: File, options?: LocalFilePreviewPanelOptions) {
  const backLabel =
    options?.backLabel ??
    i18n.t("questioninput.back_to_context", { defaultValue: "Back to context" })
  const onBack = options?.preserveSidebarStack
    ? () => useContentSidebarStore.getState().popPanel()
    : undefined
  const panel = {
    id: "local-file-preview",
    title: file.name,
    headerMode: "custom" as const,
    renderHeader: (context: ContentSidebarHeaderContext) => (
      <LocalFilePreviewSidebarHeader
        backLabel={backLabel}
        closeable={context.closeable}
        isFocusable={context.isFocusable}
        isFocused={context.isFocused}
        title={file.name}
        onBack={onBack}
        onClose={context.onClose}
        onToggleFocus={context.onToggleFocus}
      />
    ),
    content: <LocalFilePreviewContent file={file} />,
    focusable: true,
    closeable: true,
    resizable: true,
  }

  const sidebarStore = useContentSidebarStore.getState()
  if (options?.preserveSidebarStack) {
    sidebarStore.pushPanel(panel)
  } else {
    sidebarStore.openPanel(panel)
  }
}
